import { Translations } from '@diagentech/exprworks-rule-engine';
import { TranslationContext } from '@diagentech/exprworks-ui-components';
import React from 'react';

interface TranslationProviderProps {
  children: React.ReactNode;
  translations: Translations;
}

export const TranslationProvider: React.FC<TranslationProviderProps> = ({ children, translations }) => (
  <TranslationContext.Provider value={translations}>{children}</TranslationContext.Provider>
);
